import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 14.306c-2.975 0-5.976-.756-5.976-2.444 0-.7.516-1.637 2.974-2.156a.75.75 0 1 1 .31 1.468 3.775 3.775 0 0 0-1.747.69c.311.323 1.8.942 4.439.942s4.127-.619 4.439-.942a3.571 3.571 0 0 0-1.6-.658.75.75 0 1 1 .333-1.463c2.32.529 2.807 1.444 2.807 2.119-.003 1.688-3.004 2.444-5.979 2.444Zm.167-10.272a1.208 1.208 0 1 0 1.207 1.207 1.208 1.208 0 0 0-1.207-1.207Zm0 8.5a.748.748 0 0 0 .678-.431l2.44-5.2a3.51 3.51 0 0 0 .429-1.665 3.547 3.547 0 1 0-6.842 1.309c0 .014.01.029.016.044l.048.106 2.552 5.408a.75.75 0 0 0 .679.429Zm-1.9-6.526a2.046 2.046 0 1 1 3.943-.767 2.082 2.082 0 0 1-.269.992l-1.78 3.791L6.3 6.065l-.02-.035Z';
const draw24px =
  'M12.131,21.832c-4.783,0-9.626-1.252-9.626-3.643,0-2.326,4.248-3.16,6.075-3.41a.772.772,0,1,1,.209,1.529c-3.35.459-4.741,1.452-4.741,1.881,0,.628,2.75,2.1,8.083,2.1s8.083-1.471,8.083-2.1c0-.347-1.055-1.279-4.192-1.8a.771.771,0,1,1,.252-1.522c3.485.575,5.483,1.785,5.483,3.32C21.757,20.58,16.915,21.832,12.131,21.832Zm2.7-14.153A2.421,2.421,0,1,0,12.413,10.1,2.424,2.424,0,0,0,14.834,7.679Zm-1.543,0a.878.878,0,1,1-.878-.877A.879.879,0,0,1,13.291,7.679Zm-.877,11.858a.772.772,0,0,0,.7-.443l4.144-8.83a5.424,5.424,0,0,0,.669-2.585,5.511,5.511,0,1,0-11.022,0,5.454,5.454,0,0,0,.4,2.035.6.6,0,0,0,.026.071l4.392,9.31a.77.77,0,0,0,.7.442ZM8.758,9.212,8.74,9.164a3.973,3.973,0,1,1,7.138.408l-3.466,7.382L8.758,9.212Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PlaceMeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'placeMe'),
) as IconWithRender;

PlaceMeIcon.displayName = 'PlaceMeIcon';
PlaceMeIcon.propTypes = Icon.propTypes;
PlaceMeIcon.renderIcon = (props) => <PlaceMeIcon {...props} />;
export default PlaceMeIcon;
